import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Person } from '../../models/person';

@Component({
  standalone: false,
  selector: 'app-modal-edit-person-on-entry',
  templateUrl: './modal-edit-person-on-entry.component.html',
styleUrls:  ['./modal-edit-person-on-entry.component.css']
})
export class ModalEditPersonOnEntryComponent implements OnInit {

  person: Person;
  role: string;
  change$: EventEmitter<string> = new EventEmitter<string>();
  saved$: EventEmitter<Person> = new EventEmitter<Person>();

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }


  handleChangePerson(role: string){
  	this.change$.emit(role);
  }

  onSavePerson(person: Person){
  	this.saved$.emit(person);
  }

}
